var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12 4.62451c.2455 0 .4496.17688.4919.41013l.0081.08987v10.38249l1.7265-1.7265c.1736-.1736.443-.1929.6379-.0579l.0692.0579c.1736.1735.1929.443.0579.6378l-.0579.0693-2.58 2.5801c-.1736.1735-.443.1928-.6379.0578l-.0693-.0578-2.58003-2.5801c-.19526-.1953-.19526-.5119 0-.7071.17356-.1736.44299-.1929.63786-.0579l.06925.0579 1.72652 1.7265v-10.38249c0-.27614.2239-.5.5-.5zm7.2612 11.87549c.2455 0 .4496.1769.492.4101l.008.0899v2.5488c0 .2455-.1768.4496-.4101.492l-.0899.008h-14.2612c-.24546 0-.44961-.1768-.49194-.4101l-.00806-.0899v-2.5488c0-.2761.22386-.5.5-.5.24546 0 .44961.1769.49194.4101l.00806.0899v2.048h13.261l.0002-2.048c0-.2455.1769-.4496.4102-.4919z",
    fill: "#4265da",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.15454c22c81294587361017dae10c9a8.svg";
export { ForwardRef as ReactComponent };